import { createAction } from '@reduxjs/toolkit'

const getSsoCompanies = createAction('sso/getSsoCompanies')

export const ssoActions = {
  getSsoCompanies,
}
